<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/catalogs')" style="cursor: pointer">Catálogos</li>
        <li class="breadcrumb-item active" aria-current="page">Requerimientos de Grupos de Familia</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <md-card>
            <md-card-header>
              <div class="md-title">Requerimientos de Grupos de Familia
                <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="editReq='New'">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head>ID</md-table-head>
                  <md-table-head>Grupo de Familia</md-table-head>
                  <md-table-head>Sección</md-table-head>
                  <md-table-head>Orden</md-table-head>
                  <md-table-head>Requerimiento</md-table-head>
                  <md-table-head>Tipo de Campo</md-table-head>
                  <md-table-head>Valores Posibles</md-table-head>
                  <md-table-head>Activo</md-table-head>
                  <md-table-head>Acciones</md-table-head>
                </md-table-row>
                <md-table-row v-if="editReq==='New'">
                  <md-table-cell>{{editReq}}</md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Grupo de Familia</label>
                      <md-select v-model="family_group">
                        <md-option :value="fg.id" v-for="fg in family_groups" :key="fg.id">{{fg.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Sección</label>
                      <md-select v-model="section" md-dense>
                        <md-option :value="s.id" v-for="s in sections" :key="s.id">{{s.id}} - {{s.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Orden</label>
                      <md-input v-model="order" type="number"/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Requerimiento</label>
                      <md-textarea v-model="requirement" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Tipo de Campo</label>
                      <md-select v-model="field_type">
                        <md-option :value="ftype" v-for="ftype in field_types" :key="ftype">{{ftype}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Valores posibles</label>
                      <md-textarea v-model="possible_values" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="is_active"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell style="width: 16%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarReq()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-for="fg_req in fg_reqs" :key="fg_req.id">
                  <md-table-cell>{{fg_req.id}}</md-table-cell>

                  <md-table-cell v-if="editReq===fg_req.id">
                    <md-field>
                      <label>Grupo de Familia</label>
                      <md-select v-model="family_group">
                        <md-option :value="fg.id" v-for="fg in family_groups" :key="fg.id">{{fg.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_req.family_group}}</md-table-cell>

                  <md-table-cell v-if="editReq===fg_req.id">
                    <md-field>
                      <label>Sección</label>
                      <md-select v-model="section" md-dense>
                        <md-option :value="s.id" v-for="s in sections" :key="s.id">{{s.id}} - {{s.name}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_req.section}}</md-table-cell>

                  <md-table-cell v-if="editReq===fg_req.id">
                    <md-field>
                      <label>Orden</label>
                      <md-input v-model="order" type="number"/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_req.order}}</md-table-cell>

                  <md-table-cell v-if="editReq===fg_req.id">
                    <md-field>
                      <label>Requerimiento</label>
                      <md-textarea v-model="requirement" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_req.requirement}}</md-table-cell>

                  <md-table-cell v-if="editReq===fg_req.id">
                    <md-field>
                      <label>Tipo de Campo</label>
                      <md-select v-model="field_type">
                        <md-option :value="ftype" v-for="ftype in field_types" :key="ftype">{{ftype}}</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_req.field_type}}</md-table-cell>

                  <md-table-cell v-if="editReq===fg_req.id">
                      <md-field>
                          <label>Valores posibles</label>
                          <md-textarea v-model="possible_values" md-autogrow/>
                      </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{fg_req.possible_values}}</md-table-cell>

                    <md-table-cell style="text-align: center" v-if="editReq===fg_req.id">
                        <label class="container">
                            <input type="checkbox" class="form-control" v-model="is_active"/>
                            <span class="checkmark" />
                        </label>
                    </md-table-cell>
                    <md-table-cell v-else style="text-align: center">
                        <label class="container">
                            <input type="checkbox" class="form-control" v-model="fg_req.is_active" disabled/>
                            <span class="checkmark" />
                        </label>
                    </md-table-cell>

                  <md-table-cell style="width: 20%;text-align: center" v-if="editReq===fg_req.id">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarReq()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                  <md-table-cell v-else style="width: 20%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised md-primary" v-on:click="editarReq(fg_req)">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="borrarReq(fg_req.id)">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">
  export default  {
    name: 'fg-reqs',
    props: [],
    mounted() {
      this.getFgReqs();
      axios.get( '/api/catalogs/family_groups').then(response => {
        this.family_groups = response.data.data;
      });
      axios.get( '/api/catalogs/sections').then(response => {
        this.sections = response.data.data;
      });
    },
    data() {
      return {
        family_groups: [],
        sections: [],
        fg_reqs: [],
        field_types: [
          'text','textarea','textdigits','email','tel','date','time','datetime','checkbox','radio','number','url','select','multiselect','currency','multicheckbox'
        ],
        editReq: null,
        family_group: null,
        section: null,
        order: null,
        requirement: null,
        field_type: null,
        possible_values: null,
        is_active: null,
      }
    },
    methods: {
      limpiar(){
        this.editReq = null;
        this.family_group = null;
        this.section = null;
        this.order = null;
        this.requirement = null;
        this.field_type = null;
        this.possible_values = null;
        this.is_active = null;
      },
      getFgReqs(){
        axios.get( '/api/catalogs/fg_reqs').then(response => {
          this.fg_reqs = response.data.data;
        });
      },
      guardarReq(){
        Vue.toasted.show('Guardando Requerimiento...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/fg_reqs/save', {
          'id': this.editReq === 'New' ? -1 : this.editReq,
          'family_group_id': this.family_group,
          'section_id': this.section,
          'order': this.order,
          'requirement': this.requirement,
          'field_type': this.field_type,
          'possible_values': this.possible_values,
          'is_active': this.is_active
        }).then(response => {
          this.limpiar();
          this.getFgReqs();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Requerimiento guardado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editarReq(req){
        this.editReq = req.id;
        this.family_group = req.family_group_id;
        this.section = req.section_id;
        this.order = req.order;
        this.requirement = req.requirement;
        this.field_type = req.field_type;
        this.possible_values = req.possible_values;
        this.is_active = req.is_active;
      },
      borrarReq(rid){
        Vue.toasted.show('Borrando Requerimiento...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/fg_reqs/delete', {
          'id': rid,
        }).then(response => {
          this.getFgReqs();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Requerimiento borrado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
    },
    computed: {

    }
}
</script>

<style scoped>
    /* Customize the label (the container) */
    .container {
        display: block;
        position: relative;
        padding-left: 35px;
        margin-bottom: 35px;
        cursor: pointer;
        font-size: 22px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #eee;
        margin-left: 30%;
        border-radius: 30px;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: rgb(243, 205, 33);
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
</style>
